//* Libraries imports
import { z } from "zod";

export const baseDocumentDTOSchema = z
  .object({
    _id: z.string().optional(),
    name: z.string().optional(),
    category: z.string().optional(),
    document: z.string().optional(),
    document_name: z.string().optional(),
    tags: z.array(z.string()).optional(),
    enterpriseId: z.string().optional(),
    createdAt: z.union([z.string(), z.date()]).optional(),
    updatedAt: z.union([z.string(), z.date()]).optional(),
  })
  .catchall(z.any());

export const templateOutputDTOSchema = baseDocumentDTOSchema;
export const techinicalOutputDTOSchema = baseDocumentDTOSchema;
